import React from 'react';
import img from '../../Media/hero-pepid-advisor-v1.png'

const Section4 = () => {
    return (
        <div className='bg-pic-3 bg-cover py-10'>
            <div className='grid grid-cols-12 w-10/12 mx-auto items-center gap-5'>
                <div className='text-white col-span-12 md:col-span-6'>
                    <p className='font-bold'>Everything you need in one powerful app</p>
                    <h5 className='text-5xl font-bold mb-10'>WELCOME TO PEPID.</h5>
                    <p className='text-xl'>Established in 1994, PEPID’s complete catalog of healthcare information solutions supports thousands of institutions across the globe. Extensive, intuitive, and easily integrated – PEPID’s clinical and drug databases strengthen critical decision-making at any point-of-care and beyond.WATCH OVERVIEW VIDEO</p>
                    <button className='text-2xl font-bold text-white bg-red-500 hover:bg-red-600 px-6 py-2 rounded-full my-5'>WATCH OVERVIEW VIDEO</button>
                </div>
                <div className='col-span-12 md:col-span-6'>
                    <img src={img} alt="" />
                </div>
            </div>
        </div>
    );
};

export default Section4;